import { createSelector } from "reselect";
import { ApplicationState, CommonState } from "@idw-types/state";
import { DEFAULT_COUNTRY_CODE } from "@constants/form-constants";

export const getCommonState = (state: ApplicationState) => {
	return state.common;
};

export const getRedirectUrl = createSelector(getCommonState, (commonState: CommonState) => {
	return commonState.redirectUrl;
});

export const getCountry = createSelector(getCommonState, (commonState: CommonState) => {
	return commonState.country || DEFAULT_COUNTRY_CODE;
});

export const getVerificationError = createSelector(getCommonState, (commonState: CommonState) => {
	return commonState.verificationError || null;
});

export const getShouldUpdateSubmitButton = createSelector(getCommonState, (commonState: CommonState) => {
	return commonState.shouldUpdateSubmitButton;
});

export const getForceShowAppVersion = createSelector(getCommonState, (commonState: CommonState) => {
	return commonState.forceShowAppVersion;
});